const config = require(process.env.CONFIG_PATH)
export default config.default
